import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const UsernameFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='USUARIO' htmlFor='input-username' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='username'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-username'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsernameFormGroup)
